(function () {
  if (typeof window === 'undefined' || Shopify && Shopify.designMode) return;

  var STORAGE_KEY = 'mj-exit-offer-dismissed';
  var COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

  function wasDismissedRecently() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      return !isNaN(ts) && Date.now() - ts < COOLDOWN_MS;
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  function init() {
    var panel = document.querySelector('[data-mj-exit-offer]');
    if (!panel || wasDismissedRecently()) return;

    var shown = false;
    var delayMs = parseInt(panel.getAttribute('data-delay-ms'), 10) || 28000;
    var closeBtn = panel.querySelector('[data-mj-exit-close]');
    var form = panel.querySelector('#MJExitOfferForm');
    var success = panel.querySelector('.mj-exit-offer__success');

    function show() {
      if (shown || wasDismissedRecently()) return;
      if (document.body.classList.contains('popup-open') || document.body.classList.contains('drawer-open')) return;
      shown = true;
      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.classList.add('is-visible');
      });
    }

    function hide(persist) {
      panel.classList.remove('is-visible');
      window.setTimeout(function () {
        panel.hidden = true;
      }, 320);
      if (persist !== false) markDismissed();
    }

    if (closeBtn) closeBtn.addEventListener('click', function () { hide(true); });

    if (form) {
      form.addEventListener('submit', function () {
        window.setTimeout(function () {
          if (form.querySelector('.mj-exit-offer__success')) hide(true);
        }, 400);
      });
    }
    if (success) hide(true);

    // Desktop : exit intent (curseur vers le haut de la fenêtre)
    document.addEventListener('mouseout', function (e) {
      if (shown || e.relatedTarget || e.clientY > 12) return;
      show();
    });

    // Mobile / fallback : délai + scroll léger (non bloquant)
    window.setTimeout(function () {
      if (shown) return;
      var onScroll = function () {
        var maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        var progress = (window.scrollY || 0) / maxScroll;
        if (progress >= 0.12) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }, delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
